module.exports = () => {
  _.mixin({
    deepMapKeys(accumulator, iterator, context) {
      return _.transform(accumulator, (result, value, key) => {
        key = iterator.call(context, value, key, accumulator);

        if (_.isObject(value)) {
          result[key] = _.deepMapKeys(value, iterator, context);
        } else {
          result[key] = value;
        }
      });
    },
  });
};



// WEBPACK FOOTER //
// ./main/config/initializers/lodash.js